import { cn } from '@shared/lib/cn'

interface HintMessageProps {
  message?: string
  className?: string
}

export function HintMessage({ message, className }: HintMessageProps) {
  if (!message) return null
  return <p className={cn('typo-tag text-disabled', className)}>{message}</p>
}
